import React, { useState, useEffect } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import Question from 'on_web/components/shared/Question/Question';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';
import { getCovid19Contact } from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

function DiseasesStep3(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedInContact, setSelectedInContact] = useState(
    context &&
      context.covidPastInfections &&
      context.covidPastInfections
        .contact_with_individual_covid_19_diagnosis_symptoms != null
      ? context.covidPastInfections
          .contact_with_individual_covid_19_diagnosis_symptoms
      : undefined
  );

  const { t } = useTranslation();
  const questions = getCovid19Contact(selectedInContact, t);

  const onClickNext = () => {
    let covidPastInfections = context ? context.covidPastInfections : null;

    if (props.onClickNext && covidPastInfections) {
      covidPastInfections.contact_with_individual_covid_19_diagnosis_symptoms =
        selectedInContact == '1' ? 1 : selectedInContact == '0' ? 0 : null;
      props.onClickNext(covidPastInfections);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.diseasesSection.diseasesStep3.sectionTitle1'
        )}
        radioSelection={{ items: questions, twoColumns: true }}
        onAnswer={val => setSelectedInContact(val)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={selectedInContact == null}
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}

export default DiseasesStep3;
